import { Button } from "antd";
import React from "react";
import { FiFolder } from "react-icons/fi";
import { motion } from "framer-motion";

const buttonVariants = {
  hover: {
    scale: 1.1,
    textShadow: "0px 0px 8px rgb(255,255,255)",
    boxShadow: "0px 0px 8px rgb(255,255,255)",
    transition: {
      duration: 0.3,
      yoyo: 5,
    },
  },
};

const OtherProject = () => {
  const onchange = () => {
    var dots = document.getElementById("dots");
    var moreText = document.getElementById("more");
    var button = document.getElementById("button");

    if (dots.classList.contains("hidden")) {
      // Show the dots
      dots.classList.remove("hidden");

      // Hide the more text
      moreText.classList.add("hidden");

      // change text of the button
      button.innerHTML = "See more";
    } else {
      // Hide the dots
      dots.classList.add("hidden");

      // hide the more text
      moreText.classList.remove("hidden");

      // change text of the button
      button.innerHTML = "See less";
    }
  };

  return (
    <div className="w-full h-full pt-10">
      <h1 className="text-white text-2xl">Other Noteworthy Projects</h1>
      <h1 className="text-green-300 text-md pt-2 pb-4">View the archived</h1>
      <div className="w-full flex flex-wrap justify-center gap-3">
        <div className="bg-[#112240] opacity-100 h-96 w-96 p-4 flex flex-col gap-6">
          <FiFolder className="w-8 h-8 text-green-400" />
          <h1 className="text-xl text-green-300">Sina pizza delivery</h1>
          <h1 className="text-white text-sm">
            Developed the frontend user interface using modern technologies like
            React.js, ensuring a visually appealing and user-friendly design for
            browsing menu items, customizing orders, and adding items to the
            cart. Implemented a backend system using Node.js and Express.js to
            handle order management, authentication, and API integrations with
            payment gateways and third-party delivery services.
          </h1>

          <h1 className="text-gray-500 text-sm">
            HTML,CSS,Bootstrap React.js, Node.js , Redux Toolkit , Express.js ,
            MongoDB
          </h1>
        </div>
        <div className="bg-[#112240] opacity-100 h-96 w-96 p-4 flex flex-col gap-6">
          <FiFolder className="w-8 h-8 text-green-400" />
          <h1 className="text-xl text-green-300">
            Aleta Wondo Primary Hospital
          </h1>
          <h1 className="text-white text-sm">
            hospital operations and improve patient care. Implemented features
            such as patient registration, appointment scheduling, electronic
            medical records management, and real-time bed availability tracking.
          </h1>

          <h1 className="text-gray-500 text-sm">
            HTML,CSS,Bootstrap React.js, Node.js , Redux Toolkit , Express.js ,
            MongoDB
          </h1>
        </div>
        <div className="bg-[#112240] opacity-100 h-96 w-96 p-4 flex flex-col gap-6">
          <FiFolder className="w-8 h-8 text-green-400" />
          <h1 className="text-xl text-green-300">Hayo Tutor Finder</h1>
          <h1 className="text-white text-sm">
            A comprehensive tutor finder website connecting students with
            skilled tutors. As a full stack developer, I designed and developed
            the platform using React.js, Node.js, and MongoDB. Implemented user
            authentication, search functionality, and messaging features for
            seamless tutor-student interactions. firm based in its place of
            origin.
          </h1>

          <h1 className="text-gray-500 text-sm">
            HTML,CSS,Tailwind css, React.js, Node.js , Redux Toolkit ,
            Express.js , MongoDB
          </h1>
        </div>
        <div className="bg-[#112240] opacity-100 h-96 w-96 p-4 flex flex-col gap-6">
          <FiFolder className="w-8 h-8 text-green-400" />
          <h1 className="text-xl text-green-300">Movie Store</h1>
          <h1 className="text-white text-sm">
            Built a responsive and intuitive movie browsing interface using
            React.js, allowing users to explore a vast collection of films and
            easily filter by genre, release date, and other criteria.
          </h1>

          <h1 className="text-gray-500 text-sm">
            HTML,CSS,Tailwind css, Next.js, Node.js , Express.js , MongoDB
          </h1>
        </div>
        <div className="bg-[#112240] opacity-100 h-96 w-96 p-4 flex flex-col gap-6">
          <FiFolder className="w-8 h-8 text-green-400" />
          <h1 className="text-xl text-green-300">Hayo School</h1>
          <h1 className="text-white text-sm">
            Played a key role in building a student management system using
            Angular, Express.js, and MongoDB. Developed features for student
            registration, attendance tracking, and grade management. Integrated
            a notification system for important announcements and events,
            fostering effective communication among school stakeholders.
          </h1>

          <h1 className="text-gray-500 text-sm">
            HTML,CSS,Material Ui, Angular, Node.js , Express.js , MongoDB ,
            TypeScript
          </h1>
        </div>
        <div className="bg-[#112240] opacity-100 h-96 w-96 p-4 flex flex-col gap-6">
          <FiFolder className="w-8 h-8 text-green-400" />
          <h1 className="text-xl text-green-300">Habesha</h1>
          <h1 className="text-white text-sm">
            Implemented a user feedback and rating system to enhance trust and
            authenticity within the dating community. Developed moderation tools
            and automated checks to ensure the integrity of user profiles and
            prevent fraudulent activities.
          </h1>

          <h1 className="text-gray-500 text-sm">
            HTML,CSS,Tailwind css, React.js, Node.js , Redux Toolkit ,
            Express.js , MongoDB
          </h1>
        </div>
      </div>

      <span id="dots">...</span>
      <div id="more" className="hidden ">
        <div className="w-full flex flex-wrap justify-center gap-3 pt-4">
          <div className="bg-[#112240] opacity-100 h-96 w-96 p-4 flex flex-col gap-6">
            <FiFolder className="w-8 h-8 text-green-400" />
            <h1 className="text-xl text-green-300">Aleta Wondo TVET Collage</h1>
            <h1 className="text-white text-sm">
              Designed and developed a comprehensive school management system
              using React.js, Node.js, and MongoDB. Implemented features such as
              student enrollment, attendance tracking, grade management, and
              communication channels between teachers, students, and parents,
              resulting in streamlined administrative processes and enhanced
              communication within the school community.
            </h1>

            <h1 className="text-gray-500 text-sm">
              HTML,CSS,Tailwind css, React.js, Node.js , Redux Toolkit ,
              Express.js , MongoDB
            </h1>
          </div>
          <div className="bg-[#112240] opacity-100 h-96 w-96 p-4 flex flex-col gap-6">
            <FiFolder className="w-8 h-8 text-green-400" />
            <h1 className="text-xl text-green-300">Tikus</h1>
            <h1 className="text-white text-sm">
              Collaborated with UI/UX designers to create a visually appealing
              and intuitive mobile application for food delivery. Implemented
              features such as geolocation, restaurant search, and secure
              payment processing using technologies like React Native,
              Express.js, and Stripe.
            </h1>

            <h1 className="text-gray-500 text-sm">
              HTML,CSS,Tailwind css, React Native, Node.js , Express.js ,
              MongoDB
            </h1>
          </div>
          <div className="bg-[#112240] opacity-100 h-96 w-96 p-4 flex flex-col gap-6">
            <FiFolder className="w-8 h-8 text-green-400" />
            <h1 className="text-xl text-green-300">Ale</h1>
            <h1 className="text-white text-sm">
              Led the development of a comprehensive bedroom finder web
              application using React.js, Node.js, and MongoDB. Implemented a
              user-friendly interface for searching and filtering bedroom
              listings based on location, price range, and amenities. Integrated
              user authentication, enabling users to save favorite listings and
              submit inquiries directly to property owners.
            </h1>

            <h1 className="text-gray-500 text-sm">
              HTML,CSS,Tailwind css, React.js, Node.js , Redux Toolkit ,
              Express.js , MongoDB
            </h1>
          </div>
          <div className="bg-[#112240] opacity-100 h-96 w-96 p-4 flex flex-col gap-6">
            <FiFolder className="w-8 h-8 text-green-400" />
            <h1 className="text-xl text-green-300">Sidama Tour</h1>
            <h1 className="text-white text-sm">
              Developed a comprehensive tourist application using React.js and
              Node.js. Implemented interactive maps, real-time weather updates,
              and integrated APIs for attractions and accommodations, providing
              users with a seamless and immersive travel experience.
            </h1>

            <h1 className="text-gray-500 text-sm">
              HTML,CSS,Tailwind css, React.js, Node.js , Redux Toolkit ,
              Express.js , MongoDB
            </h1>
          </div>
          <div className="bg-[#112240] opacity-100 h-96 w-96 p-4 flex flex-col gap-6">
            <FiFolder className="w-8 h-8 text-green-400" />
            <h1 className="text-xl text-green-300">My Reminder</h1>
            <h1 className="text-white text-sm">
              Developed and maintained a custom reminder application using
              React.js, Node.js, and MongoDB. Implemented user authentication
              and authorization, created reminder scheduling functionality, and
              optimized the application for scalability and performance.
            </h1>

            <h1 className="text-gray-500 text-sm">
              HTML,CSS,Tailwind css, React.js, Node.js , Redux Toolkit ,
              Express.js , MongoDB
            </h1>
          </div>
          <div className="bg-[#112240] opacity-100 h-96 w-96 p-4 flex flex-col gap-6">
            <FiFolder className="w-8 h-8 text-green-400" />
            <h1 className="text-xl text-green-300">Manager Special</h1>
            <h1 className="text-white text-sm">
              Developed a food delivery platform using React.js, Node.js, and
              MongoDB. Created an intuitive user interface for ordering food,
              integrated real-time tracking of delivery drivers, and optimized
              the platform for scalability and performance, resulting in
              increased customer satisfaction and streamlined operations.
            </h1>

            <h1 className="text-gray-500 text-sm">
              HTML,CSS,Tailwind css, React.js, Node.js , Redux Toolkit ,
              Express.js , MongoDB
            </h1>
          </div>
        </div>
      </div>

      <motion.button
        variants={buttonVariants}
        whileHover="hover"
        id="button"
        className="my-10 w-44 px-5 py-4 hover:cursor-pointer border-2 hover:border-green-400 border-green-400 rounded-lg  hover:scale-110 hover:text-green-300 text-green-400 duration-300 "
        onClick={onchange}
      >
        See More
      </motion.button>
    </div>
  );
};

export default OtherProject;
